[
    {
        "name": "Policies",
        "href": "/",
        "submenu": [
            {
                "name": "Terms Of Use",
                "href": "/terms-of-use",
                "submenu": null
            },
            {
                "name": "Privacy Policy",
                "href": "/privacy-policy",
                "submenu": null
            },
            {
                "name": "Cookies Policy",
                "href": "/cookies-policy",
                "submenu": null
            },
            {
                "name": "Conflict of Interests Policy",
                "href": "/conflict-policy",
                "submenu": null
            },
            {
                "name": "Regulatory Disclosures",
                "href": "/regulatory",
                "submenu": null
            }
        ]
    },
    {
        "name": "Site Map",
        "href": "https://www.devere-group.com/site-map/",
        "submenu": null
    }
]